<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="relative max-w-md w-full">
      <div class="card transition-all hover:scale-105 hover:shadow-xl">
        <div class="text-center mb-6">
          <div class="mx-auto w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
          </div>
          <h2 class="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h2>
          <p class="text-gray-600">Sign in to your account</p>
        </div>

        <form class="" @submit.prevent="handleLogin">
          <div class="mb-4">
            <label for="email" class="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
            <input
              id="email"
              v-model="form.email"
              name="email"
              type="email"
              required
              class="w-full"
              placeholder="Enter your email"
            />
          </div>

          <div class="mb-4">
            <label for="password" class="block text-sm font-semibold text-gray-700 mb-2">Password</label>
            <input
              id="password"
              v-model="form.password"
              name="password"
              type="password"
              required
              class="w-full"
              placeholder="Enter your password"
            />
          </div>

          <div v-if="error" class="mb-4 p-4 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
            {{ error }}
          </div>

          <button
            type="submit"
            :disabled="authStore.loading"
            class="w-full bg-blue-600 text-white py-3 px-4 mb-2 rounded-lg font-semibold hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="authStore.loading" class="flex items-center justify-center">
              <div class="loading mr-2"></div>
              Signing in...
            </span>
            <span v-else>Sign In</span>
          </button>
        
          <div class="text-center">
            <router-link to="/forgot-password" class="text-blue-600 text-sm mb-4 block">Forgot your password?</router-link>
            <div class="border-t border-gray-300 mb-4"></div>
            <router-link to="/register" class="btn btn-secondary">Create Account</router-link>
          </div>
        </form>
      </div>

      <div class="mt-6 text-center">
        <p class="text-sm text-gray-600">© 2025 Retailer Management System</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import type { LoginCredentials } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const form = ref<LoginCredentials>({
  email: '',
  password: ''
})

const error = ref('')

async function handleLogin() {
  error.value = ''
  try {
    await authStore.login(form.value)

    if (authStore.isAdminVendor) router.push('/dashboard')
    else if (authStore.isSalesVendor) router.push('/pos')
    else if (authStore.isCustomer) router.push('/catalog')
  } catch (err: unknown) {
    const apiError = (err as { error?: unknown })?.error
    error.value =
      typeof apiError === 'string'
        ? apiError
        : 'Login failed. Please check your credentials.'
  }
}
</script>
